import { Label } from "../../../components/ui/label";
import { Calendar } from "../../../components/ui/calendar";
import { Input } from "../../../components/ui/input";
import { ptBR, enUS } from "date-fns/locale";
import { SLOT_STEP } from "../utils";

interface DateTimeSectionProps {
  t: any;
  lang: string;
  date: Date;
  setDate: (date: Date) => void;
  startTime: string;
  setStartTime: (time: string) => void;
  endTime: string;
  setEndTime: (time: string) => void;
}

export function DateTimeSection({
  t,
  lang,
  date,
  setDate,
  startTime,
  setStartTime,
  endTime,
  setEndTime,
}: DateTimeSectionProps) {
  return (
    <section className="space-y-4 pt-4 border-t">
      <div className="space-y-2">
        <Label className="text-sm font-bold text-neutral-700 uppercase tracking-wider">{t.editModal.date}</Label>
        <div className="border rounded-xl bg-white shadow-sm overflow-hidden p-1">
          <Calendar
            mode="single"
            selected={date}
            onSelect={(d) => d && setDate(d)}
            locale={lang === "pt" ? ptBR : enUS}
            className="w-full"
            classNames={{
              cell: "h-8 w-full text-center text-sm p-0 relative",
              day: "h-8 w-8 p-0 font-normal aria-selected:opacity-100 mx-auto",
              head_cell: "text-neutral-500 rounded-md w-full font-normal text-[0.8rem] py-1",
              table: "w-full border-collapse space-y-1",
            }}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div className="space-y-2">
          <Label className="text-sm font-bold text-neutral-700 uppercase tracking-wider">{t.editModal.start}</Label>
          <Input
            type="time"
            step={SLOT_STEP * 60}
            value={startTime}
            onChange={(e) => setStartTime(e.target.value)}
            className="h-10"
          />
        </div>
        <div className="space-y-2">
          <Label className="text-sm font-bold text-neutral-700 uppercase tracking-wider">{t.editModal.end}</Label>
          <Input
            type="time"
            step={SLOT_STEP * 60}
            value={endTime}
            onChange={(e) => setEndTime(e.target.value)}
            className="h-10"
          />
        </div>
      </div>
    </section>
  );
}
